"use client";

import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "@/components/ThemeProvider";

interface ProvidersProps {
  children: React.ReactNode;
}

/**
 * Root providers wrapper component.
 *
 * Wraps the application with essential providers:
 * - SessionProvider: NextAuth session management
 * - ThemeProvider: CSS custom properties for theming
 *
 * The ThemeProvider is initialized without tenant context here,
 * which applies default colors. Specific pages/layouts can override
 * the theme by using a nested ThemeProvider with tenant colors.
 */
export function Providers({ children }: ProvidersProps) {
  return (
    <SessionProvider>
      <ThemeProvider>
        {children}
      </ThemeProvider>
    </SessionProvider>
  );
}
